module.exports = __webpack_public_path__ + "static/media/fontawesome-main.8d121dc7.png";